interface GradientPoint {
  color: string; // 색상
  stop: number; // gradient 종료 지점(%)
}

export const linearGradient = (points: [GradientPoint, ...GradientPoint[]]) => {
  const color_stops = points.map(({ color, stop }) => `${color} ${stop}%`);
  return `linear-gradient(90deg, ${color_stops.join(', ')}), linear-gradient(90deg, ${color_stops.join(', ')})`;
};
